import { useEffect } from 'react';
import { i18n } from '@lingui/core';
import { messages as messagesEn } from './i18n/lingui/en/messages.js';
import { messages as messagesUk } from './i18n/lingui/uk/messages.js';
import { messages as messagesRu } from './i18n/lingui/ru/messages.js';
import { messages as messagesEs } from './i18n/lingui/es/messages.js';

type Messages = {
    [key: string]: Record<string, string>;
};

type Locale = 'en' | 'uk' | 'ru' | 'es' | string;

const allMessages: Messages = {
    en: messagesEn,
    uk: messagesUk,
    ru: messagesRu,
    es: messagesEs
};

export const defaultLocale = 'uk';

export function activateLingui(locale: Locale) {
    const messages = allMessages[locale] ?? allMessages.uk;
    i18n.load({ [locale]: messages });
    i18n.activate(locale);
}

export function useLinguiInit(locale: Locale) {
    const isClient = typeof window !== 'undefined';
    const messages = allMessages[locale];

    if (!messages) {
        console.warn(
            `No messages found for locale "${locale}". Falling back to "uk".`
        );
    }

    // SSR / first render
    if (!isClient && locale !== i18n.locale) {
        i18n.loadAndActivate({ locale, messages: messages ?? allMessages.uk });
    }

    // First client render
    if (isClient && !i18n.locale) {
        i18n.loadAndActivate({ locale, messages: messages ?? allMessages.uk });
    }

    // Update on locale change (e.g. back/forward browser buttons)
    useEffect(() => {
        if (locale !== i18n.locale) {
            activateLingui(locale);
        }
    }, [locale]);
}
